import React, { useEffect } from "react";
import { useBusyBlockerContext } from "../../contexts/busy-blocker-context";

/** Component that shows our fullscreen BusyBlocker */
export const GlobalLoading = () => {
	const { busyBlocker } = useBusyBlockerContext();

	useEffect(() => {
		const disposable = busyBlocker.begin();
		return () => disposable.dispose();
	}, [busyBlocker]); // Add this

	return <></>;
};
GlobalLoading.displayName = "GlobalLoading";
